import React from 'react';
import { PriceBox, AddressRow } from '../../molecules';
import { Grid, Grow, Stack } from '@mui/material';

export const CustomerAddressRow = ({
    customerContactNo,
    address1,
    address2,
    postalCode,
    city,
    country,
}) => {
    return (
        <div className='order-row-container-custom'>
            <Grid container spacing={2} className='namebox-container spacing' id="custom-topping">
                <Grid item md={3}>
                    <PriceBox textSize='md' topText={"Customer contact"} bottomText={customerContactNo} />
                </Grid>
                <Grid item md={9}>
                 <AddressRow titleCls={"topText text"} boxCls={"details-address-box text"} address1={address1} address2={address2} postalCode={postalCode} city={city} country={country} />

                </Grid>
            </Grid>
        </div>
    )
}
